import React, { useEffect, useState } from 'react';
import addnote from '../../../src/assets/Schedule/ScheudleAddnote.svg'
import ToastMessage from '../../utils/mui/righttoptoast';
import api from '../../api/api';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DateCalendar, PickersDay } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import ScheduleModal from './schedulemodal';
import { Backdrop, CircularProgress } from '@mui/material';
import openEmrApi from '../../api/openemrapi';
import { getPracticeId } from '../../config/practice';
import { isDateBookable, isSlotFull, isTypeAllowed, slotColorClass, slotRuleError } from "../providerSlotRules";
import { bookingDepartmentId, pickedProvider, pickedSlot } from "../bookingDepartment";
import { useBookingDepartment } from "../useBookingDepartment";
import BookingDepartmentSelect from "../BookingDepartmentSelect";

const CustomDateCalendar = styled(DateCalendar, {
  shouldForwardProp: (prop) => true, // forward all props
})(({ theme }) => ({
  '& .MuiPickersCalendarHeader-label': {
    fontSize: '15px',
    borderRadius:'0px'
  },  '& .Mui-selected': {
    borderRadius: '0px !important', // force square selected date
  },
}));
const AppointmentCard = ({
  handleaddnoteClick,tableData,selectedCard,
 selectedDate,
   isorderschedule, selectedscheduleorder,
   orderOptions,
  showTextArea,selectedAppointment,selectedOrders, setSelectedOrders,
  setSelectedDate,fetchdata,provider,providername,setProvidername,appointmentType, setAppointmentType, 
  setProvider,selectedSlot,setSelectedSlot,appointmentname,setAppointmentName,isReschedule,rowId}) => {
   const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
       const [note, setNote] = useState("");
      //  const [provider, setProvider] = useState("");
      //  const [selectedSlot,setSelectedSlot]=useState('')
      //  const[appointmentname,setAppointmentName]=useState('')
      //  const [providername,setProvidername]=useState('');
      const [recordingby, setRecordingby] = useState("");
        const [isLoading, setIsLoading] = useState(false);
    const [toastSeverity, setToastSeverity] = useState('success');
  const[slotsdata,setSlotsData]=useState([])
  const [providersList,setProviderslist]=useState([])
  const[appointmenttypes,setAppointmentTypes]=useState([])
  const [deleteloading,setDeleteloading]=useState(false)
  const[createloading,setCreateLoading]=useState(false);
    const[futureSlotsData,setFutureSlotsData]=useState([])
  const [rescheduleLoading,setrescheduleLoading]=useState(false);
  let firstName = localStorage.getItem('firstname');
  let lastName = localStorage.getItem('lastname');
    let user=localStorage.getItem('user')
  const [schedulemodal,setSchedulemodal]=useState(false)
  const practiseid = getPracticeId();
  // Department field (owner 10-28): the picked provider's department for the
  // picked date, else the open visit's; staff may change it. Below every value
  // it reads (slotsdata, providersList and the provider/date/slot props).
  const bookingDept = useBookingDepartment({
    slots: slotsdata,
    selectedSlot,
    providers: providersList,
    providerId: provider,
    visitDate: selectedDate?.format?.('YYYY-MM-DD'),
    requested: selectedAppointment?.departmentid,
  });
  function formatTime(time24) {
  const [hour, minute] = time24.split(':').map(Number);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
}

  const clearAllStates = () => {
    setProvidername('');  // Clear provider name
    setAppointmentName('');  // Clear appointment name
    setProvider('');  // Clear provider ID
    setAppointmentType('');  // Clear appointment type
    setSelectedSlot('');  // Clear selected slot
    setNote('');  // Clear notes if needed
  };
dayjs.extend(utc);
dayjs.extend(timezone);

// Normalize to local day (remove UTC influence)
// const highlightedDates = tableData?.map(item =>
//   dayjs(item.startdate).local().startOf('day')
// );

const highlightedDates = React.useMemo(() => {
  if (!futureSlotsData?.length) return [];

  return futureSlotsData
    .filter((item) => item.is_available === true)
    .map((item) => dayjs(item.date));
}, [futureSlotsData]);

// The endpoint reports a window around the selected date, so it can only tell
// us about days inside it. Days it explicitly marks unavailable (the provider
// does not work then, or is blocked) get disabled; days it says nothing about
// stay selectable rather than looking blocked.
const availabilityByDate = React.useMemo(() => {
  const map = new Map();
  (futureSlotsData || []).forEach((item) => {
    if (item?.date && dayjs(item.date).isValid()) {
      map.set(dayjs(item.date).format('YYYY-MM-DD'), item.is_available === true);
    }
  });
  return map;
}, [futureSlotsData]);

const shouldDisableDate = React.useCallback(
  (day) => availabilityByDate.get(dayjs(day).format('YYYY-MM-DD')) === false
    // a weekday the provider's booking rules leave out (7825 only)
    || !isDateBookable(provider, day),
  [availabilityByDate, provider]
);

// const highlightedDates = [
//   dayjs('2025-07-09T18:30:00.000Z').startOf('day'),
//   dayjs('2025-07-10T18:30:00.000Z').startOf('day'),
// ];
    
    const getProviders=async()=>{
      try {
        const response=await api.get(`/v1/${practiseid}/providers`)
        if(response.status===200){
          setProviderslist(response.data)
             console.log('provider',providersList)
          const providerIds = response.data.map(provider => provider.providerid);
          const appresponse=await api.post(`/v1/${practiseid}/appointment/types`,{
            "providerid":providerIds
        })
      
        if(appresponse.status===200){
           setAppointmentTypes(appresponse.data)
          //  if(appresponse?.data?.length){
          //   setAppointmentType(appresponse?.data[0]?.value)
          //   setAppointmentName(appresponse?.data[0]?.appointmenttypeid)
          //  }
           setAppointmentType("");
           setAppointmentName("");
        }else{
          setAppointmentTypes([])
        }
        }else{
          setProvider([])
        }
        // if(response?.data?.length){
        //   setProvider(response?.data[0]?.providerid)
        //   setProvidername(response?.data[0]?.providername)
        //   await getslots(response?.data[0]?.providerid,selectedDate.format('YYYY-MM-DD'))
        //       }
    
    
      } catch (error) {
        
      }finally{
      }
    }

   
    const getProviderOpenslots=async(id,dt)=>{
        console.log("provideridOS",id)
		setFutureSlotsData([])
        try {
          const response=await api.post(`/v1/${practiseid}/provider-future-open-slots`,{
          "providerid": id,
          "startdate": dt
          })
          if(response.status===200){
            setFutureSlotsData(response?.data ?? []);
          }else{
            console.log("Unexpected Error response");
          }
        } catch (error) {
          console.log(error)
        }
    }    

    const getslots=async(id,dt)=>{


        try {
          const response=await api.post(`/v1/${practiseid}/scheduler/daywise-open-slots`,{
          "providerid": id,
          "startdate": dt
          })
          if(response.status===200){
           
            setSlotsData(response.data)
          }else{
            setSlotsData([])
          }
        } catch (error) {
          console.log(error)
        }
    }
    
    const providerChange = async (e) => {
      setProvider(e);

      if (e === "") {
        setProvider('');
        setFutureSlotsData([])
        setSlotsData([]);  // Clear the available slots
        return;  // Do not proceed with fetching slots
      }

      console.log("Provider selected:", e);  // Check the value of e
      const selectedProvider = providersList.find((item) => item.providerid == e);
      
      if (selectedProvider) {
    
        setProvidername(selectedProvider?.providername);

        console.log("Provider set:", e);  // Ensure provider is set correctly
        await getProviderOpenslots(e, selectedDate.format("YYYY-MM-DD"));
        getslots(e, selectedDate.format("YYYY-MM-DD"));
      } else {
        // Never keep the previous provider's name next to a new id.
        setProvidername('');
        console.error("No matching provider found.");
      }
    };
    
    const appointmentChange=(e)=>{
      setAppointmentType(e)
      console.log(e,'ee')
      const selectedAppointmentname=appointmenttypes.find((item)=>item.value==e)
      console.log(selectedAppointment,'seee')
       setAppointmentName(selectedAppointmentname?.appointmenttypeid)


    }
    
      const handleDateChange = async(newDate) => {
		setFutureSlotsData([])
        setSelectedDate(newDate);  // Update the selected date state
           const selectedProvider = providersList.find((item) => item.providername == providername);
        // No provider picked yet → nothing to fetch. Sending providerid ""
        // made both slot endpoints 400 and raised an error toast when the
        // user clicked Today in the date picker (QA video 1220731699).
        if (!selectedProvider?.providerid) {
            setSlotsData([]);
            return;
        }
        await getslots(String(selectedProvider.providerid),newDate.format('YYYY-MM-DD'))
        await getProviderOpenslots(String(selectedProvider.providerid),newDate.format('YYYY-MM-DD'));
    };
    
      const handleToastClose = () => {
        setOpenToast(false);
    };

    useEffect(()=>{
       getProviders()
    },[])

useEffect(() => {
  if (!appointmentType || !providersList?.length) return;

  // run only when provider NOT selected
  if (providername) return;

  const apptPrefix = appointmentType.trim().slice(0, 3).toLowerCase();

  if (apptPrefix === "art") {
    const matchedProvider = providersList.find((p) => {
      const provPrefix = p?.providername?.trim().slice(0, 3).toLowerCase();
      return provPrefix === "art";   // case-insensitive match
    });
    console.log("Matched provider for ART:", matchedProvider);

    if (matchedProvider) {
      setProvider(matchedProvider.providerid);
      setProvidername(matchedProvider.providername);
    }
  }
}, [appointmentType, providersList]);


    /* "provider" and "providerid" for create / reschedule, both read from ONE
       providers-list entry, the one for the selected id (the id is what the
       slots and the Athena booking use). They were sent from two separately
       set states and could drift apart, e.g. a reschedule picking the id from
       the row but the name from the row's (reassigned) provider label
       (2026-09-30). Only when the list has no entry for the id is the pair
       sent as held, and then never with an empty name: a reschedule keeps the
       row's own name when the id is still the row's provider. */
    const selectedProviderFields = () => {
      const picked = providersList.find(
        (item) => String(item?.providerid) === String(provider)
      );
      if (picked) {
        return { provider: picked.providername, providerid: picked.providerid };
      }
      const row = isReschedule ? tableData?.[selectedCard] : null;
      const rowName =
        row && String(row.providerid) === String(provider) ? row.providername : "";
      return { provider: providername || rowName || "", providerid: provider };
    };

    /* The department a create, create_multiple_schedule or reschedule asks
       for: the picked provider's department for the picked date, else the
       open visit's (never CODE for a provider who is not at CODE that day).
       schedule/bookingDepartment.js, the API's booking rule. */
    const bookingDepartment = () => bookingDepartmentId({
      slot: pickedSlot(slotsdata, selectedSlot),
      provider: pickedProvider(providersList, provider),
      providerId: provider,
      visitDate: selectedDate?.format?.('YYYY-MM-DD'),
      requested: selectedAppointment?.departmentid,
    });

    const createappointment=async({AppointmentNote})=>{

        if(!appointmentType){
        setToastMessage('Please Select Appointment Type');
        setToastSeverity('error');
        setOpenToast(true);
        return
        }
      if(!provider){
        setToastMessage('Please Select Provider');
        setToastSeverity('error');
        setOpenToast(true);
        return
      }
      if (!selectedSlot) {
        setToastMessage('Please Select Time Slot');
        setToastSeverity('error');
        setOpenToast(true);
        return;
      }
      // Per-provider booking rules (7825 only; none elsewhere).
      const slotRuleMsg = slotRuleError({ providerid: provider, providername, appointmentType, date: selectedDate, slot: selectedSlot, slots: slotsdata });
      if (slotRuleMsg) {
        setToastMessage(slotRuleMsg);
        setToastSeverity('error');
        setOpenToast(true);
        return;
      }
      try {
        setCreateLoading(true)
let response;
          if(practiseid==1111){

            console.log(appointmentname)
//     response=await openEmrApi.post(`/scheduler/create/`,{
         
// "apikey":'bmkxeyjfqpwapjqedzj',
//   // "patientid":selectedAppointment?.pc_pid,
//   "purpose": appointmentType,
//   "startDatetime": startDatetime,
//   "endDateTime": endDateTime,
//   "minutesDuration": minutesDuration ,

//    purpose_id: appointmentname,
 
//    "providerid":provider
//       })
          }else{
   response=await api.post(`/v1/${practiseid}/scheduler/patient/${selectedAppointment?.patientid}/create_schedule`,{
          ...bookingDept.fields(bookingDepartment()), // rule dept, or staff pick + department_override
          "startdate": selectedDate.format('YYYY-MM-DD'),
          "starttime": selectedSlot,
          // provider + providerid from one providers-list entry
          ...selectedProviderFields(),
          "appointmenttype": appointmentType,
          "appointmenttypeid": appointmentname,
          "notes":AppointmentNote
          
      })
          }
           
      
      if(response.status==200){
           fetchdata()
        setToastMessage('  Appointment created successfully');
        setToastSeverity('success');
        setOpenToast(true);
        setTimeout(() => {
          clearAllStates()
 
        }, 1000); // 1200ms = 1.2 secon
      }else{
        setToastMessage('Failed to create schedule. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
        
      } catch (error) {
        console.log(error)
        setToastMessage('Something Went Wrong');
        setToastSeverity('error');
        setOpenToast(true);
      }finally{
      setCreateLoading(false)
      }
    }
      const scheduleappointment=async()=>{
setSchedulemodal(false)
        if(!appointmentType){
        setToastMessage('Please Select Appointment Type');
        setToastSeverity('error');
        setOpenToast(true);
        return
        }
      if(!provider){
        setToastMessage('Please Select Provider');
        setToastSeverity('error');
        setOpenToast(true);
        return
      }
      // Per-provider booking rules (7825 only; none elsewhere).
      const slotRuleMsg = slotRuleError({ providerid: provider, providername, appointmentType, date: selectedDate, slot: selectedSlot, slots: slotsdata });
      if (slotRuleMsg) {
        setToastMessage(slotRuleMsg);
        setToastSeverity('error');
        setOpenToast(true);
        return;
      }
// Step 1: Extract first ordername for each ordertype
// Step 1: Extract first ordername per ordertype

const mappedOrdernames = [];
const seenOrdertypes = new Set();
const task=selectedOrders[0]

for (const order of selectedOrders) {
  if (order.ordertype === "labs") {
    if (!seenOrdertypes.has("labs")) {
      mappedOrdernames.push("LAB ORDERS-CUSTOM");
      seenOrdertypes.add("labs");
    }
  } else if (order.ordertype === "procedures") {
    // Include all procedure ordernames (no uniqueness check)
    mappedOrdernames.push(order.ordername);
  } else {
    if (!seenOrdertypes.has(order.ordertype)) {
      mappedOrdernames.push(order.ordername);
      seenOrdertypes.add(order.ordertype);
    }
  }
}

console.log("Mapped Ordernames for appointmenttypeid match:", mappedOrdernames);

// Match with appointmenttypes
// const matchedAppointmentTypeIds = appointmenttypes
//   .filter(item => mappedOrdernames.includes(item.value))
//   .map(item => item.appointmenttypeid);



const allids=selectedOrders.map((x)=>x.id)


   setIsLoading(true)
      try {
      
        setCreateLoading(true)
        const response=await api.post(`/v1/${practiseid}/scheduler/patient/${selectedAppointment?.patientid}/create_multiple_schedule`,{
          ...bookingDept.fields(bookingDepartment()), // rule dept, or staff pick + department_override
          "startdate": selectedDate.format('YYYY-MM-DD'),
          "starttime": selectedSlot,
          // provider + providerid from one providers-list entry
          ...selectedProviderFields(),
          // "appointmenttype": appointmentType,
          // "appointmenttypeid": appointmentname,
          "notes":note,
          //
  "appointmenttypes": mappedOrdernames||[], 
"appointmenttypeids":Array(mappedOrdernames.length||0).fill(appointmentname)
           // "appointmenttypeids": matchedAppointmentTypeIds,
      })
      if(response.status==200){
         const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array
          
              if (!taskToProcess) {
                console.error("No task data available");
                return;
              }
          
              // Extract data from the task (using taskToProcess to ensure consistency)
              const fullName = `${firstName} ${lastName}`;
              const payload = {
                ids: allids,
                status: taskToProcess.status,
                notes: taskToProcess.notes,
                orderdate: dayjs(taskToProcess.ts).format('YYYY-MM-DD'),
                login_user: user,
                ordertype: taskToProcess.ordertype,
                username: fullName
              };
          
              // Make API call to mark as complete
             await api.put(`/v1/${practiseid}/tasks/${taskToProcess.patientid}/mark_as_complete`, payload);
           fetchdata()
        setToastMessage('  Appointment created successfully');
        setToastSeverity('success');
        setOpenToast(true);
        setTimeout(() => {
          setSelectedOrders([])
          clearAllStates()
 
        }, 1000); // 1200ms = 1.2 secon
      }else{
        setToastMessage('Failed to create schedule. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
        
      } catch (error) {
        console.log(error)
        setToastMessage('Something Went Wrong');
        setToastSeverity('error');
        setOpenToast(true);
      }finally{
        setIsLoading(false)
      setCreateLoading(false)
      }
    }
    const handleNoteChange = (event) => {
      setNote(event.target.value);
    };
    
   const rescheduleAppointment = async ({rowId}) => {
          // Per-provider booking rules (7825 only; none elsewhere).
          const slotRuleMsg = slotRuleError({ providerid: provider, providername, appointmentType, date: selectedDate, slot: selectedSlot, slots: slotsdata });
          if (slotRuleMsg) {
            setToastMessage(slotRuleMsg);
            setToastSeverity('error');
            setOpenToast(true);
            return;
          }

          setrescheduleLoading(true);
          try {
            const res = await api.post(`/v1/${practiseid}/scheduler/patients/${rowId.patientid}/rescheduleappointment`, {
              appointmentid: rowId.appointmentid,
              current_startdate: rowId.startdate
,
              new_startdate:selectedDate.format('YYYY-MM-DD'),
              new_starttime:`${selectedSlot}:00`,
   ...bookingDept.fields(bookingDepartment()), // rule dept, or staff pick + department_override
       
          // "starttime": selectedSlot,
          // provider + providerid from one providers-list entry
          ...selectedProviderFields(),
          "appointmenttype": appointmentType,
          "appointmenttypeid": appointmentname,
          "notes":note
            });
        
            if (res.status === 200) {
              fetchdata()
              console.log('Appointment rescheduled successfully');
              setToastMessage('Appointment rescheduled successfully');
              setToastSeverity('success');
              setOpenToast(true);
              setTimeout(() => {
                clearAllStates();
                
              }, 1200);
            } else {
              console.log('Failed to reschedule appointment');
              setToastMessage('Failed to reschedule appointment');
              setToastSeverity('info');
              setOpenToast(true);
            }
          } catch (error) {
            console.log('Error rescheduling appointment:', error);
            setToastMessage('Something Went Wrong');
            setToastSeverity('error');
            setOpenToast(true);
          } finally {
            setrescheduleLoading(false);
          }
        };

      //  useEffect(()=>{
      //   if(isReschedule){
      //     setIsLoading(true)
      //    setAppointmentType(tableData[selectedCard]?.type||'')
      // const selectedAppointmentname=appointmenttypes.find((item)=>item.value==tableData[selectedCard]?.type||'')
      //  setAppointmentName(selectedAppointmentname?.appointmenttypeid) 
   
       
      // const selectedProvider = providersList.find((item) => item.providername== tableData[selectedCard]?.providername);
      // console.log(tableData[selectedCard]?.providername,'sel',providersList)
      // if (selectedProvider) {
      //   setProvider(tableData[selectedCard]?.providerid)
      //   setProvidername(selectedProvider?.providername);

      //   getslots(tableData[selectedCard]?.providerid, selectedDate.format("YYYY-MM-DD"));
      //   setIsLoading(false)
      // } else {
      //   console.error("No matching provider found.");
      // }
      //   }
    

      //  },[selectedCard,isReschedule,providersList,appointmenttypes]) 

useEffect(() => {
  if (isReschedule) {
    setIsLoading(true);

    // Log to see what values you're working with
    console.log('tableData[selectedCard]:', tableData[selectedCard]);
    console.log('providersList:', providersList);

    // Set the appointment type
    setAppointmentType(tableData[selectedCard]?.type || '');

    // Set appointment name
    const selectedAppointmentname = appointmenttypes.find(
      (item) => item.value === tableData[selectedCard]?.type || ''
    );
    setAppointmentName(selectedAppointmentname?.appointmenttypeid);

    // Log the provider name before searching
    const providerName = tableData[selectedCard]?.providername;
    console.log('Provider name to search for:', providerName);

    // Find the matching provider: the row's providerid first (its label can
    // be a reassigned provider's name), then the name. Id and name are then
    // both taken from that one entry so they cannot disagree.
    const rowProviderId = tableData[selectedCard]?.providerid;
    const selectedProvider =
      providersList.find(
        (item) => rowProviderId != null && String(item.providerid) === String(rowProviderId)
      ) || providersList.find((item) => item.providername === providerName);
    console.log('Selected provider found:', selectedProvider);

    // If provider is found, update the state and fetch slots
    if (selectedProvider) {
      setProvider(selectedProvider.providerid);
      setProvidername(selectedProvider.providername);
      getslots(selectedProvider.providerid, selectedDate.format('YYYY-MM-DD'));
      setIsLoading(false);
    } else {
      console.error('No matching provider found.');
      setIsLoading(false);  // Stop loading if no provider is found
    }
  }
}, [selectedCard, isReschedule, providersList, appointmenttypes]);

const recordingProvider = selectedAppointment?.signintime?.BlinkscribeRecordingBy ?? null;
console.log("recordingProviderAC", recordingProvider);

// Function to get providerId by name
const getProviderIdByName = (providerName) => {
  const matchedProvider = providersList.find(providerItem => {
    console.log(providerItem.providername, providerName);
    console.log(providerItem.providerid);
    return providerItem.providername.trim() === providerName.trim();
  });

  if (matchedProvider) {
    return matchedProvider.providerid;
  } else {
    console.log("unmatched");
    return null;
  }
};

useEffect(() => {
  if (recordingProvider && providersList.length > 0) {
    // Find the provider object in the list
    const cleanName = (name) => name.toLowerCase().replace(/^(dr\.|md|do)\s*/i, "").trim();

    const providerObj = providersList.find((p) => {
      return cleanName(recordingProvider).includes(cleanName(p.providername));
    });

    if (providerObj) {
      const providerId = providerObj.providerid;
      // Update local state
      setRecordingby(providerId);
      // Call the onChange handler
      providerChange(providerId);
    } else {
      // Reset if no match
      setRecordingby("");
    }
  }
}, [recordingProvider, providersList, setRecordingby]);


const isProviderMatched = (typeof provider === 'string' && 
    (provider.includes("Leanora") || 
     provider.includes("Reshma") || 
     ['15', '17'].includes(provider))) ||
    (Array.isArray(provider) && provider.some(p => p === "Leanora" || p === "Reshma"));

  if (!isProviderMatched) {
    console.log("No matching provider found.");
  }

  return (
        <div className="flex  w-full">
             <div className=" w-full flex  flex-col sm:flex-row  h-auto min-h-[240px] rounded-lg p-4 m-4 bg-white  shadow-lg gap-4">
               <div className="w-full sm:w-[350px]  bg-white border-2 border-[#50869A] shadow-sm rounded-xl ">
<LocalizationProvider dateAdapter={AdapterDayjs}>
<CustomDateCalendar
        minDate={dayjs()}
        shouldDisableDate={shouldDisableDate}
        value={selectedDate}
        onChange={handleDateChange}
        slots={{
          day: (props) => {
            const { day, selected, ...other } = props;
            const isHighlighted = highlightedDates?.length
              ? highlightedDates.some((d) => dayjs(d).isSame(dayjs(day), 'day'))
              : false;
            

            return (
              <PickersDay
                {...other}
                day={day}
                selected={selected}
                sx={{
                  ...(isHighlighted && {
                    backgroundColor: '#2e7d32', // Changed to green
                    color: '#fff',
                    borderRadius: '10%',
                    '&:hover': {
                      backgroundColor: '#1b5e20', // Darker green on hover
                    },
                  }),
                }}
              />
            );
          },
        }}
      />
</LocalizationProvider>


               </div>
   
               <div className="flex flex-col h-full w-full ">
                 <div className="flex  w-[100%] gap-4 justify-between ">
                   <div className='flex gap-4  w-[100%] '>
                   <div className="flex items-center gap-6 py-0 space-x-4">
     <div className="relative flex flex-col py-0 m-0 items-start w-[280px]">
       <div className='font-inter text-[14px] mb-1 text-[#50869A]'>Appointment Type</div>
<div className="relative w-[280px]">
  <select
    id="appointmentType"
    value={appointmentType || ''}
    onChange={(e) => appointmentChange(e.target.value)}
    className="h-10 px-2 text-sm font-medium border-2 border-[#50869A] w-full rounded-md focus:outline-none appearance-none pr-8 bg-white"
  >
    <option value="">Select Appointment Type</option>
    {appointmenttypes.filter((type) => isTypeAllowed(provider, type?.value, selectedDate)).map((type, index) => (
      <option key={index} value={type?.value}>
        {type?.value}
      </option>
    ))}
  </select>

  {/* Custom Arrow Icon */}
  <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
  <g opacity="0.5">
    <path d="M4.5 6L8.5 10L12.5 6" stroke="#09090B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</svg>
  </div>
</div>


     </div>
   
     <div className="relative flex flex-col py-0 m-0">
       <div className='font-inter text-left text-[14px]  w-[280px] mb-1 text-[#50869A]'>Provider</div>
<div className="relative w-[280px]">
  <select
    id="providers"
    value={provider || recordingby || ''}
    onChange={(e) => providerChange(e.target.value)}
    className="h-10 px-2 text-sm font-medium border-2 border-[#50869A] rounded-md w-full appearance-none pr-8 bg-white focus:outline-none"
  >
    <option value="">Select Provider</option>
    {providersList.map((providerItem) => (
      <option key={providerItem.providerid} value={providerItem.providerid}>
        {providerItem.providername}
      </option>
    ))}
  </select>

  {/* Custom Arrow Icon */}
  <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
   <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
  <g opacity="0.5">
    <path d="M4.5 6L8.5 10L12.5 6" stroke="#09090B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</svg>
  </div>
</div>

     </div>
     <BookingDepartmentSelect
       value={bookingDept.departmentId}
       ruleValue={bookingDept.ruleDepartment}
       onChange={bookingDept.setPicked}
       wrapperClassName="relative flex flex-col py-0 m-0 w-[160px]"
       labelClassName="font-inter text-left text-[14px] mb-1 text-[#50869A]"
       className="h-10 px-2 text-sm font-medium border-2 border-[#50869A] rounded-md w-full bg-white focus:outline-none"
     />
                       </div>
                   <img onClick={handleaddnoteClick} style={{width:"24px"}} src={addnote} className='mt-6 cursor-pointer' alt='%$'/>
                   </div>
                   <div className='min-w-[150px]'>
  <button
    className='bg-[#E17954] font-inter text-white text-xs rounded px-3 py-2'
    onClick={() => {
      if (isReschedule) {
        rescheduleAppointment({rowId});
      }else if (isorderschedule){
         if(!appointmentType){
        setToastMessage('Please Select Appointment Type');
        setToastSeverity('error');
        setOpenToast(true);
        return
        }
      if(!provider){
        setToastMessage('Please Select Provider');
        setToastSeverity('error');
        setOpenToast(true);
        return
      }
        setSchedulemodal(true)
// scheduleappointment({ AppointmentNote: note })
      } else {
        createappointment({ AppointmentNote: note });
      }
    }}
  >
    {isReschedule ? 'Reschedule' :isorderschedule ? '+ Create Appointment' : 'Save'}
  </button>
</div>

                 </div>
                 <div className='w-full'>
                     {showTextArea && (
           <textarea rows={4}
           value={note} // Set textarea value from state
           onChange={handleNoteChange}
             placeholder="Add any additional notes......" 
             className="mt-4 w-full p-2 border rounded"
           />
         )}
         </div>
                 <div className=" flex flex-col">
                 <div className='font-inter text-left text-[15px]  mb-1 mt-2 text-[#50869A]'>Time Slots</div>
                 <div className="flex flex-wrap gap-2 w-full items-center justify-center">
                 {provider ? (
    slotsdata.length > 0 ? (
      <div className="flex flex-wrap gap-2 w-full items-center justify-center">
        {slotsdata.map((slot) => (
     <button
  onClick={() => setSelectedSlot(slot.starttime)}
  key={slot.starttime}
  className={`px-4 py-2 text-sm font-semibold border-[1.5px] border-[#50869A] rounded-md
    ${slotColorClass(slot.appointment_count, provider, selectedDate)}
    ${selectedSlot === slot.starttime ? ' text-[#50869A] bg-gray-200' : 'hover:bg-gray-200 text-[#50869A]'}
    focus:ring-2 focus:ring-gray-200 focus:outline-none`}
    disabled={isSlotFull(slot, provider, selectedDate)}
>
  {formatTime(slot.starttime)}
  {slot.appointment_count > 0 && (
    <span className="ml-2 font-normal">({slot.appointment_count})</span>
  )}
</button>


        ))}
      </div>
    ) : (
      <p className="text-md text-gray-500 bg-gray-100 px-4 py-2 rounded">
        No open slots available for this provider!
      </p>
    )
  ) : (
    <p className="text-md text-gray-500 bg-gray-100 px-4 py-2 rounded">
      Please select a provider to see available slots.
    </p>
  )}
</div>
                 </div>
               </div>
          
             </div>
             <ScheduleModal scheduleappointment={scheduleappointment}  selectedOrders={selectedOrders} setSelectedOrders={setSelectedOrders} selectedscheduleorder={selectedscheduleorder} ismodal={schedulemodal} setModal ={setSchedulemodal} orderOptions={orderOptions} />
             <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
                     />
                     <Backdrop
                                            sx={{
                                              color: 'secondary.main', // Sets the CircularProgress color to secondary
                                              backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                                              zIndex: (theme) => theme.zIndex.drawer + 1
                                            }}
                                            open={isLoading}
                                          >
                                            <CircularProgress color="secondary" />
                                          </Backdrop>
           </div>
  )
}

export default AppointmentCard